// Global utility functions
// These are exposed on window for use throughout the application

// Shows toast notification message
window.showToast = function (message, cssClass) {
  cssClass = cssClass || "alert alert-success";
  window.dispatchEvent(new CustomEvent("show-toast", { detail: { message: message, css_class: cssClass } }))
}

// Scrolls to a selector with offset for fixed header
window.scrollToSelector = function (selector, offset) {
  offset = offset || 0;
  const yOffset = -document.querySelector("header").clientHeight + offset;
  const element = document.querySelector(selector);
  if (element) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

